import { forwardRef, lazy, memo, Suspense } from 'react';
import type { CKEditor } from '@ckeditor/ckeditor5-react';
import type { InlineEditor as CKInlineEditor } from '@ckeditor/ckeditor5-editor-inline';

import { InlineEditorProps } from './InlineEditor.types';
import { MarkdownRenderer } from '../../common/markdown/MarkdownRenderer';

export * from './InlineEditor.types';

const LazyInlineEditor = lazy(() => import('./InlineEditor').then((module) => ({ default: module.InlineEditor })));

export type InlineEditorInstance = CKEditor<CKInlineEditor>;

const InlineEditorBase = (props: InlineEditorProps, ref: React.ForwardedRef<InlineEditorInstance>) => {
  return (
    <Suspense fallback={<MarkdownRenderer content={props.data || ''} />}>
      <LazyInlineEditor {...props} ref={ref} />
    </Suspense>
  );
};

export const InlineEditor = memo(forwardRef(InlineEditorBase));
